// Image tabs component for switching between multiple images
import React from 'react';
import { HStack, Text, Button, IconButton } from '@chakra-ui/react';
import { Image as ImageIcon, X, Plus } from 'lucide-react';
import { ImageItem } from '../types';

interface ImageTabsProps {
  images: ImageItem[];
  currentIndex: number;
  onTabClick: (index: number) => void;
  onRemove: (id: string) => void;
  onAddMore: () => void;
}

export const ImageTabs: React.FC<ImageTabsProps> = ({
  images,
  currentIndex,
  onTabClick,
  onRemove,
  onAddMore,
}) => {
  return (
    <HStack spacing={2} overflowX="auto" pb={2}>
      {images.map((img, idx) => (
        <HStack
          key={img.id}
          px={4}
          py={2}
          bg={currentIndex === idx ? 'brand.primary.DEFAULT' : 'background.secondary'}
          borderRadius="lg"
          cursor="pointer"
          onClick={() => onTabClick(idx)}
          transition="all 0.2s"
          minW="fit-content"
          spacing={2}
          border="1px solid"
          borderColor={currentIndex === idx ? 'brand.primary.DEFAULT' : 'border.default'}
        >
          <ImageIcon size={14} color={currentIndex === idx ? '#fff' : '#475467'} />
          <Text
            fontSize="sm"
            color={currentIndex === idx ? 'white' : 'text.primary'}
            maxW="150px"
            isTruncated
            fontFamily="secondary"
          >
            {img.file.name}
          </Text>
          <IconButton
            aria-label="Remove image"
            icon={<X size={12} />}
            size="xs"
            variant="ghost"
            color={currentIndex === idx ? 'white' : 'text.secondary'}
            _hover={{ bg: currentIndex === idx ? 'whiteAlpha.200' : 'background.tertiary' }}
            onClick={(e) => {
              e.stopPropagation();
              onRemove(img.id);
            }}
            minW={4}
            h={4}
          />
        </HStack>
      ))}
      <Button
        leftIcon={<Plus size={14} />}
        size="sm"
        variant="ghost"
        color="text.secondary"
        _hover={{ color: 'text.primary', bg: 'background.secondary' }}
        onClick={onAddMore}
        fontFamily="secondary"
      >
        Add More
      </Button>
    </HStack>
  );
};
